const invalidMoulageRules = {
  'LEFT_FOOT': [
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'LEFT_LEG_LOWER',
      triggeringMoulages: [        
        'AMPUTATION_CLEAN_LOWER', 
        'AMPUTATION_MESSY_LOWER', 
        'AMPUTATION_BLAST_LOWER',
        'FRACTURE_CLOSED_LOWER',
      ],
      message: 'Moulage not available when amputation/fracture is present on lower leg'
    },
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'LEFT_LEG_UPPER',
      triggeringMoulages: [        
        'EDEMA_MEDIUM',
        'EDEMA_LARGE',
      ],
      message: 'Moulage not available when edema is present on upper leg'
    },
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'LEFT_LEG_UPPER',
      triggeringMoulages: [        
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      message: 'Moulage not available when amputation/fracture is present on upper leg'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_EXTREMITY',
        'AMPUTATION_MESSY_EXTREMITY',
        'AMPUTATION_BLAST_EXTREMITY',
      ],
      triggeringLocation: 'ABDOMEN',
      triggeringMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      message: 'Moulage not available when gastric distension is present on abdomen'
    },
  ],
  'LEFT_LEG_LOWER': [
    {
      disabledMoulages: ['ANY'], 
      triggeringLocation: 'LEFT_LEG_UPPER', 
      triggeringMoulages: [
        'EDEMA_MEDIUM', 
        'EDEMA_LARGE',
      ],
      message: 'Moulage not available when edema is present on upper leg'
    },
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'LEFT_LEG_UPPER', 
      triggeringMoulages: [
        'AMPUTATION_CLEAN_UPPER', 
        'AMPUTATION_MESSY_UPPER', 
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      message: 'Moulage not available when amputation/fracture is present on upper leg'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',
        'FRACTURE_CLOSED_LOWER',
      ],
      triggeringLocation: 'LEFT_FOOT',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on foot'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',
      ],
      triggeringLocation: 'ABDOMEN',
      triggeringMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      message: 'Moulage not available when gastric distension is present on abdomen'
    },
  ],
  'LEFT_LEG_UPPER': [
    {
      disabledMoulages: ['EDEMA_MEDIUM', 'EDEMA_LARGE'],
      triggeringLocation: 'LEFT_LEG_LOWER',
      triggeringMoulages: ['ANY'],
      message: 'Edema not available when another moulage is present on lower leg'
    },
    {
      disabledMoulages: ['EDEMA_MEDIUM', 'EDEMA_LARGE'],
      triggeringLocation: 'LEFT_FOOT',
      triggeringMoulages: ['ANY'],
      message: 'Edema not available when another moulage is present on lower leg'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      triggeringLocation: 'LEFT_LEG_LOWER',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on lower leg'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      triggeringLocation: 'LEFT_FOOT',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on foot'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
      ],
      triggeringLocation: 'ABDOMEN',
      triggeringMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      message: 'Moulage not available when gastric distension is present on abdomen'
    },
  ],
  'RIGHT_FOOT': [
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'RIGHT_LEG_LOWER',
      triggeringMoulages: [        
        'AMPUTATION_CLEAN_LOWER', 
        'AMPUTATION_MESSY_LOWER', 
        'AMPUTATION_BLAST_LOWER',
        'FRACTURE_CLOSED_LOWER',
      ],
      message: 'Moulage not available when amputation/fracture is present on lower leg'
    },
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'RIGHT_LEG_UPPER',
      triggeringMoulages: [        
        'EDEMA_MEDIUM',
        'EDEMA_LARGE',
      ],
      message: 'Moulage not available when edema is present on upper leg'
    },
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'RIGHT_LEG_UPPER',
      triggeringMoulages: [        
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      message: 'Moulage not available when amputation/fracture is present on upper leg'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_EXTREMITY',
        'AMPUTATION_MESSY_EXTREMITY',
        'AMPUTATION_BLAST_EXTREMITY',
      ],
      triggeringLocation: 'ABDOMEN',
      triggeringMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      message: 'Moulage not available when gastric distension is present on abdomen'
    },
  ],
  'RIGHT_LEG_LOWER': [
    {
      disabledMoulages: ['ANY'], 
      triggeringLocation: 'RIGHT_LEG_UPPER', 
      triggeringMoulages: [
        'EDEMA_MEDIUM', 
        'EDEMA_LARGE',
      ],
      message: 'Moulage not available when edema is present on upper leg'
    },
    {
      disabledMoulages: ['ANY'], 
      triggeringLocation: 'RIGHT_LEG_UPPER', 
      triggeringMoulages: [
        'AMPUTATION_CLEAN_UPPER', 
        'AMPUTATION_MESSY_UPPER', 
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      message: 'Moulage not available when amputation/fracture is present on upper leg'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',
        'FRACTURE_CLOSED_LOWER',
      ],
      triggeringLocation: 'RIGHT_FOOT',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on foot'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',
      ],
      triggeringLocation: 'ABDOMEN',
      triggeringMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      message: 'Moulage not available when gastric distension is present on abdomen'
    },
  ],
  'RIGHT_LEG_UPPER': [
    {
      disabledMoulages: ['EDEMA_MEDIUM', 'EDEMA_LARGE'],
      triggeringLocation: 'RIGHT_LEG_LOWER',
      triggeringMoulages: ['ANY'],
      message: 'Edema not available when another moulage is present on lower leg'
    },
    {
      disabledMoulages: ['EDEMA_MEDIUM', 'EDEMA_LARGE'],
      triggeringLocation: 'RIGHT_FOOT',
      triggeringMoulages: ['ANY'],
      message: 'Edema not available when another moulage is present on lower leg'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      triggeringLocation: 'RIGHT_LEG_LOWER',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on lower leg'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      triggeringLocation: 'RIGHT_FOOT',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on foot'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
      ],
      triggeringLocation: 'ABDOMEN',
      triggeringMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      message: 'Moulage not available when gastric distension is present on abdomen'
    },
  ],
  'LEFT_HAND': [
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'LEFT_ARM_LOWER',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_LOWER', 
        'AMPUTATION_MESSY_LOWER', 
        'AMPUTATION_BLAST_LOWER',
        'FRACTURE_CLOSED_LOWER',
      ],
      message: 'Moulage not available when amputation/fracture is present on lower arm'
    },
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'LEFT_ARM_UPPER',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
        'EDEMA_MEDIUM',
        'EDEMA_LARGE',
      ],
      message: 'Moulage not available when amputation/fracture/edema is present on upper arm'
    },
  ],
  'LEFT_ARM_LOWER': [
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'LEFT_ARM_UPPER',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
        'EDEMA_MEDIUM',
        'EDEMA_LARGE',
      ],
      message: 'Moulage not available when amputation/fracture/edema is present on upper arm'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',
        'FRACTURE_CLOSED_LOWER',
      ],
      triggeringLocation: 'LEFT_HAND',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on hand'
    },
  ],
  'LEFT_ARM_UPPER': [
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      triggeringLocation: 'LEFT_ARM_LOWER',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on lower arm'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      triggeringLocation: 'LEFT_HAND',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on hand'
    },
  ],
  'RIGHT_HAND': [
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'RIGHT_ARM_LOWER',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_LOWER', 
        'AMPUTATION_MESSY_LOWER', 
        'AMPUTATION_BLAST_LOWER',
        'FRACTURE_CLOSED_LOWER',
      ],
      message: 'Moulage not available when amputation/fracture is present on lower arm'
    },
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'RIGHT_ARM_UPPER',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
        'EDEMA_MEDIUM',
        'EDEMA_LARGE',
      ],
      message: 'Moulage not available when amputation/fracture/edema is present on upper arm'
    },
  ],
  'RIGHT_ARM_LOWER': [
    {
      disabledMoulages: ['ANY'],
      triggeringLocation: 'RIGHT_ARM_UPPER',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
        'EDEMA_MEDIUM',
        'EDEMA_LARGE',
      ],
      message: 'Moulage not available when amputation/fracture/edema is present on upper arm'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',
        'FRACTURE_CLOSED_LOWER',
      ],
      triggeringLocation: 'RIGHT_HAND',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on hand'
    },
  ],
  'RIGHT_ARM_UPPER': [
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      triggeringLocation: 'RIGHT_ARM_LOWER',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on lower arm'
    },
    {
      disabledMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',
        'FRACTURE_CLOSED_UPPER',
      ],
      triggeringLocation: 'RIGHT_HAND',
      triggeringMoulages: ['ANY'],
      message: 'Moulage not available when another moulage is present on hand'
    },
  ],
  'ABDOMEN': [
    {
      disabledMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      triggeringLocation: 'LEFT_LEG_UPPER',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',        
      ],
      message: 'Moulage not available when amputation is present on leg'
    },
    {
      disabledMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      triggeringLocation: 'RIGHT_LEG_UPPER',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_UPPER',
        'AMPUTATION_MESSY_UPPER',
        'AMPUTATION_BLAST_UPPER',        
      ],
      message: 'Moulage not available when amputation is present on leg'
    },
    {
      disabledMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      triggeringLocation: 'LEFT_LEG_LOWER',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',        
      ],
      message: 'Moulage not available when amputation is present on leg'
    },
    {
      disabledMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      triggeringLocation: 'RIGHT_LEG_LOWER',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_LOWER',
        'AMPUTATION_MESSY_LOWER',
        'AMPUTATION_BLAST_LOWER',        
      ],
      message: 'Moulage not available when amputation is present on leg'
    },
    {
      disabledMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      triggeringLocation: 'LEFT_FOOT',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_EXTREMITY',
        'AMPUTATION_MESSY_EXTREMITY',
        'AMPUTATION_BLAST_EXTREMITY',        
      ],
      message: 'Moulage not available when amputation is present on foot'
    },
    {
      disabledMoulages: [
        'DISTENSION_SMALL',
        'DISTENSION_MEDIUM',
        'DISTENSION_LARGE',
      ],
      triggeringLocation: 'RIGHT_FOOT',
      triggeringMoulages: [
        'AMPUTATION_CLEAN_EXTREMITY',
        'AMPUTATION_MESSY_EXTREMITY',
        'AMPUTATION_BLAST_EXTREMITY',        
      ],
      message: 'Moulage not available when amputation is present on foot'
    },
  ],
};

function isInvalidMoulage(location, moulageKey, selectedMoulages) {
  const rules = invalidMoulageRules[location]
  if (!rules) {
    return
  }
  
  for (const rule of rules) {
    if (rule.disabledMoulages.includes('ANY') || rule.disabledMoulages.includes(moulageKey)) {
      const otherMoulage = selectedMoulages[rule.triggeringLocation]
      if (otherMoulage) {
        if (rule.triggeringMoulages.includes('ANY') || rule.triggeringMoulages.includes(otherMoulage)) {
          return rule.message;
        }
      }
    }
  }
}

module.exports = isInvalidMoulage;